import { useCallback, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { searchVerticalItemsByKey } from 'constants/search'
import { useGlobalHomesAndVillasSearch } from 'hooks/GlobalSearch/GlobalSearchVerticals/useGlobalHomesAndVillasSearch'
import HomesAndVillasTabContent from '../Components/Mobile/TabContents/HomesAndVillasTabContent'
import useGlobalSearchVerticalTabBooking from './useGlobalSearchVerticalTabBooking'
import { GLOBAL_SEARCH_INITIAL_STATE } from 'contexts/GlobalSearch/GlobalSearchState'
import useQueryParams from 'hooks/useQueryParams'
import LineHomeAltIcon from 'LuxKit/Icons/line/LineHomeAltIcon'

function useGlobalSearchVerticalTabHomesAndVillas(): App.GlobalSearchVerticalTabV2 {
  const intl = useIntl()
  const queryParams = useQueryParams()

  const {
    globalHomesAndVillasSearchDispatch,
    globalHomesAndVillasSearchState,
  } = useGlobalHomesAndVillasSearch(GLOBAL_SEARCH_INITIAL_STATE, queryParams)

  const {
    onSearch,
    context,
    updateSearchSessionId,
  } = useGlobalSearchVerticalTabBooking({
    globalSearchDispatch: globalHomesAndVillasSearchDispatch,
    globalSearchState: globalHomesAndVillasSearchState,
    baseSearchPath: '/search/homes-and-villas',
    baseSearchMapPath: '/search/homes-and-villas/map',
  })

  const onRequestSearch = useCallback(() => {
    return onSearch()
  }, [onSearch])

  return useMemo((): App.GlobalSearchVerticalTabV2 => ({
    label: searchVerticalItemsByKey.get('homes-and-villas')?.label ?? intl.formatMessage({
      id: '7m7fqBuHg7',
      defaultMessage: 'Homes & Villas',
      description: 'Fallback label for homes and villas search tab',
    }),
    key: 'homes-and-villas',
    context,
    onSearch: onRequestSearch,
    ContentComponent: HomesAndVillasTabContent,
    Icon: LineHomeAltIcon,
    updateSearchSessionId,
  }), [context, onRequestSearch, updateSearchSessionId, intl])
}

export default useGlobalSearchVerticalTabHomesAndVillas
